import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

const billboardImages = [
  "https://public.readdy.ai/ai/img_res/290cc2da3c97b58197f39c38b3f6988d.jpg",
  "https://readdy.ai/api/search-image?query=Authentic%20nighttime%20photograph%20of%20The%20Venetian%20Las%20Vegas%20exterior%20from%20ground%20level%20with%20massive%20LED%20billboard%20screen%20showing%20vibrant%20advertisement%20on%20building%2C%20iconic%20bell%20tower%20Campanile%20di%20San%20Marco%20replica%20illuminated%20against%20night%20sky%2C%20grand%20canal%20shoppes%20entrance%20with%20romantic%20lighting%2C%20realistic%20architectural%20details%20with%20prominent%20digital%20billboard%20display%2C%20professional%20travel%20photography%20style%2C%20warm%20ambient%20lighting%20from%20casino%20windows%20and%20bright%20LED%20screen%2C%20natural%20Las%20Vegas%20Strip%20environment%20with%20visible%20electronic%20advertising%20billboard&width=1920&height=1080&seq=hero-venetian-billboard-v3-002&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Real-life%20style%20photograph%20of%20Caesars%20Palace%20Las%20Vegas%20at%20night%20from%20street%20view%20with%20large%20digital%20LED%20billboard%20screen%20displaying%20advertisement%20on%20facade%2C%20iconic%20Roman%20statues%20and%20columns%20at%20entrance%2C%20classical%20architecture%20with%20subtle%20elegant%20lighting%20and%20bright%20electronic%20billboard%2C%20authentic%20casino%20resort%20atmosphere%20with%20visible%20digital%20advertising%20screen%2C%20professional%20architectural%20night%20photography%2C%20warm%20golden%20ambient%20lights%20and%20illuminated%20LED%20billboard%2C%20natural%20Las%20Vegas%20environment%20with%20prominent%20digital%20display%20screen&width=1920&height=1080&seq=hero-caesars-billboard-v3-003&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Genuine%20nighttime%20photograph%20of%20MGM%20Grand%20Las%20Vegas%20from%20street%20perspective%20with%20massive%20LED%20digital%20billboard%20screen%20showing%20colorful%20advertisement%20on%20building%20exterior%2C%20famous%20golden%20lion%20statue%20prominently%20displayed%20at%20main%20entrance%2C%20emerald%20green%20glass%20facade%20with%20warm%20interior%20lighting%20visible%20and%20bright%20electronic%20billboard%2C%20realistic%20architectural%20photography%20with%20visible%20digital%20advertising%20screen%2C%20professional%20travel%20photography%20style%2C%20natural%20ambient%20casino%20lighting%20and%20illuminated%20LED%20billboard%20display%2C%20authentic%20Las%20Vegas%20Strip%20atmosphere%20with%20prominent%20digital%20signage&width=1920&height=1080&seq=hero-mgm-billboard-v3-004&orientation=landscape"
];

export default function HeroSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % billboardImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <AnimatePresence mode="wait">
          <motion.img
            key={currentIndex}
            src={billboardImages[currentIndex]}
            alt="Las Vegas Billboard Advertising - Digital and Static Outdoor Advertising"
            className="w-full h-full object-cover object-center absolute inset-0"
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.2, ease: "easeInOut" }}
          />
        </AnimatePresence>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl"
        >
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black mb-4 leading-tight">
            <span className="text-white">Las Vegas Billboard Advertising</span>
            <br />
            <span className="bg-gradient-to-r from-electric-blue to-cyan-400 bg-clip-text text-transparent drop-shadow-[0_0_30px_rgba(0,212,255,0.5)]">
              Strategic Outdoor Media Assets
            </span>
          </h1>

          <motion.h2
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.8 }}
            className="text-xl md:text-2xl text-white font-bold mb-3"
          >
            Digital Billboard and Outdoor Advertising<br />
            Across High-Traffic Las Vegas Corridors
          </motion.h2>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="text-base md:text-lg text-gray-200 mb-8 max-w-2xl mx-auto leading-relaxed font-light"
          >
            Position your brand where attention is constant.
            We deliver premium digital billboard and outdoor advertising placements across key Las Vegas locations, driving sustained visibility and measurable brand growth.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <Link
              to="/en/advertise"
              className="group px-6 py-3 bg-gradient-to-r from-electric-blue to-cyan-400 text-white rounded-full font-semibold text-sm flex items-center gap-2 hover:shadow-[0_0_30px_rgba(0,212,255,0.6)] transition-all whitespace-nowrap cursor-pointer"
            >
              Start Advertising
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
            </Link>
            <Link
              to="/en/partnership"
              className="group px-6 py-3 bg-transparent border-2 border-neon-gold text-neon-gold rounded-full font-semibold text-sm hover:bg-neon-gold hover:text-black transition-all whitespace-nowrap cursor-pointer"
            >
              Explore Investment Opportunities
            </Link>
          </motion.div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1, repeat: Infinity, repeatType: 'reverse' }}
          className="absolute bottom-8"
        >
          <i className="ri-arrow-down-line text-3xl text-white/70"></i>
        </motion.div>
      </div>

      {/* Billboard indicator dots */}
      <div className="absolute bottom-20 left-1/2 -translate-x-1/2 z-20 flex gap-2">
        {billboardImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentIndex 
                ? 'bg-white w-6' 
                : 'bg-white/40 hover:bg-white/60'
            }`}
            aria-label={`Billboard ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
